import Swiper from 'swiper';

export default {
  init() {
    //sliders
    // eslint-disable-next-line
    var animationSliderInit = new Swiper('.categories-slider-init', {
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
      },
      pagination: {
        clickable: true,
        el: '.categories-gallery-pagination',
      },
    });
    // eslint-disable-next-line
    var pressSliderInit = new Swiper('.press-slider-init', {
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
      },
      pagination: {
        clickable: true,
        el: '.press-gallery-pagination',
      },
    });
    // eslint-disable-next-line
    var pressVideoSliderInit = new Swiper('.press-video-init', {
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        clickable: true,
        el: '.press-video-pagination',
      },
    });
    // eslint-disable-next-line
    var newsVideoSliderInit = new Swiper('.news-video-init', {
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        clickable: true,
        el: '.news-video-pagination',
      },
    });
    // eslint-disable-next-line
    var newsSliderInit = new Swiper('.news-slider-init', {
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
      },
      pagination: {
        clickable: true,
        el: '.news-gallery-pagination',
      },
    });
  },
  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};
